import type { PaymentMethodType } from '@patrianna/shared-patrianna-types/store/PaymentsFlowModule'

import FormSelectField from 'src/components/Form/FormSelectField'

import useSelectPaymentMethodValues from '../hooks/useSelectPaymentMethodValues'
import classes from '../styles.module.scss'

type Props = {
  paymentMethod: PaymentMethodType
}

export function FormCardSelect({ paymentMethod }: Props) {
  const { getCardValuesByPaymentMethod } = useSelectPaymentMethodValues()
  const cardValues = getCardValuesByPaymentMethod(paymentMethod)

  return <FormSelectField className={classes.cardVerificationSelect} name='selectedCardId' items={cardValues} />
}
